import { Pipe, PipeTransform } from '@angular/core';
import SampleFormat from '../../../types/sample/SampleFormat';

@Pipe({
    name: 'sampleFormat',
    standalone: true
})
export class SampleFormatPipe implements PipeTransform {

    transform(format: SampleFormat | null | undefined): string {
        switch (format) {
            case SampleFormat.G_CLASS:
                return 'G-Class Dedicated';
            case SampleFormat.MAYBACH:
                return 'Maybach Dedicated';
            case SampleFormat.STANDARD:
            default:
                return 'Standard';
        }
    }
}